export default __webpack_public_path__ + "static/blog7-7f26a82589fb071eb7fd68a95ec24cdf.jpeg";